import * as z from "zod";

export const getOmsAutoMergeOrderExamples = {
  name: "getOmsAutoMergeOrderExamples" as const,
  input: z.object({}),
  output: z.object({
    examples: z.array(
      z.object({
        customerId: z.string().nullable(),
        customerName: z.string().nullable(),
        email: z.string().nullable(),
        windowId: z.number(),
        orderId: z.string().nullable(),
        orderName: z.string().nullable(),
        fulfilledDate: z.string().nullable(),
        shippingAddress1: z.string().nullable(),
        shippingCity: z.string().nullable(),
        shippingProvinceCode: z.string().nullable(),
        shippingZip: z.string().nullable(),
      }),
    ),
  }),
};
